// The new scale bar eliminates the ScaleManager class; that is the
// recommended pattern for all future code. This class is a compatibility
// layer between old code that still uses a scale manager and new code
// that does not. You should not use this class for any new development.

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScaleBar from '../ScaleBar';
import ScaleManager from './DeprecatedScaleManager';
import { FISCAL_YEAR_FORMATS } from 'javascripts/util/fiscalFormats';

export default class ScaleBarCompat extends Component {
  static propTypes = {
    scaleManager: PropTypes.instanceOf(ScaleManager).isRequired,
    onSetDates: PropTypes.func.isRequired,
    onBarMove: PropTypes.func,
    publishing: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    publishing: false,
    hideWeekends: false,
    fiscalMonth: 1,
    fiscalYearFormat: FISCAL_YEAR_FORMATS.SINGLE_YEAR_QUARTER_LAST,
  };

  onSetVisibleDates = (visibleStartDate, visibleEndDate) => {
    const { scaleManager } = this.props;
    const oldScrollLeft = scaleManager.dateToPercentage(scaleManager.fromDate);
    const newScrollLeft = scaleManager.dateToPercentage(visibleStartDate);
    const oldScrollRight = scaleManager.dateToPercentage(scaleManager.toDate);
    const newScrollRight = scaleManager.dateToPercentage(visibleEndDate);

    // Immediately update the local scale manager and flush an update.
    // This means that the scale bar will always be exactly in sync with
    // the scroll position (whereas parent components generally throttle
    // the onSetDates or onBarMove which would create lag).
    scaleManager.fromDate = visibleStartDate;
    scaleManager.toDate = visibleEndDate;
    this.forceUpdate();

    this.props.onSetDates({
      fromDate: visibleStartDate,
      toDate: visibleEndDate,
    });

    if (
      this.props.onBarMove &&
      oldScrollLeft !== newScrollLeft &&
      oldScrollRight !== newScrollRight
    ) {
      this.props.onBarMove(newScrollLeft);
    }
  };

  render() {
    const { scaleManager, publishing } = this.props;

    return (
      <ScaleBar
        startDate={scaleManager.minDate}
        endDate={scaleManager.maxDate}
        visibleStartDate={scaleManager.fromDate}
        visibleEndDate={scaleManager.toDate}
        onSetVisibleDates={this.onSetVisibleDates}
        publishing={publishing}
        hideWeekends={scaleManager.options.hideWeekends}
        fiscalMonth={scaleManager.options.fiscalMonth}
        fiscalYearFormat={scaleManager.options.fiscalYearFormat}
      />
    );
  }
}
